<template>
  <div class="modal_wrap full_modal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal img_expansion">
        <button class="ie_btn" v-on:click="$emit('close')">
          <i class="i_x_w"></i>
        </button>
        <ul class="img_expansion_ul">
          <li class="img_expansion_li">
            <pinch-zoom>
              <img :src="url" alt="" />
            </pinch-zoom>
          </li>
        </ul>
        <!--<div class="pager">
                <div class="pager_dot on"></div>&lt;!&ndash;'on 추가'&ndash;&gt;
                <div class="pager_dot"></div>
                <div class="pager_dot"></div>
            </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    url: String,
  },
  name: 'ImageModal',
};
</script>
